/* Follow USA / EU — BF26 early access: phase switching, countdown and Klaviyo sign-up (email, then optional SMS). */
(function () {
  'use strict';

  var KLAVIYO_REVISION = '2026-07-15';
  var JOINED_KEY = 'bf26_ea_joined';

  function ts(value) {
    var t = Date.parse(value || '');
    return isNaN(t) ? null : t;
  }

  function currentPhase(root, now) {
    var end = ts(root.dataset.saleEnd);
    var pub = ts(root.dataset.publicOpen);
    var vip = ts(root.dataset.vipOpen);
    if (end && now >= end) return 'ended';
    if (pub && now >= pub) return 'public';
    if (vip && now >= vip) return 'vip';
    return 'hype';
  }

  // Which BF026 statement shows: incoming (hype), tomorrow (day before), now (sale live).
  function statementKey(root, phase, now) {
    if (phase === 'vip' || phase === 'public') return 'now';
    var tomorrow = ts(root.dataset.tomorrowFrom);
    if (phase === 'hype' && tomorrow && now >= tomorrow) return 'tomorrow';
    return 'incoming';
  }

  function statementWord(root, key) {
    if (key === 'now') return root.dataset.wordNow;
    if (key === 'tomorrow') return root.dataset.wordTomorrow;
    return root.dataset.wordHype;
  }

  function readJoined() {
    try { return window.localStorage.getItem(JOINED_KEY) === '1'; } catch (e) { return false; }
  }

  function saveJoined() {
    try { window.localStorage.setItem(JOINED_KEY, '1'); } catch (e) { /* private mode: the page still works */ }
  }

  // Returns the number in E.164 for the market's SMS country, or null when it isn't a mobile there.
  function normaliseMobile(raw, country) {
    var digits = String(raw || '').replace(/[^\d+]/g, '');
    if (country === 'AU') {
      if (digits.indexOf('+61') === 0) digits = digits.slice(3);
      else if (digits.indexOf('61') === 0 && digits.length === 11) digits = digits.slice(2);
      if (digits.charAt(0) === '0') digits = digits.slice(1);
      return /^4\d{8}$/.test(digits) ? '+61' + digits : null;
    }
    if (country === 'US') {
      digits = digits.replace(/^\+/, '');
      if (digits.length === 11 && digits.charAt(0) === '1') digits = digits.slice(1);
      return /^[2-9]\d{2}[2-9]\d{6}$/.test(digits) ? '+1' + digits : null;
    }
    return null;
  }

  function isEmail(value) {
    return /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(value);
  }

  // Lets Shopify custom pixels (and Meta/GA4 tags, if loaded on the page) count the sign-up.
  function trackSignup(phase) {
    try { if (window.Shopify && window.Shopify.analytics && window.Shopify.analytics.publish) window.Shopify.analytics.publish('bf26_early_access_signup', { phase: phase }); } catch (e) { /* tracking only */ }
    try { if (typeof window.fbq === 'function') window.fbq('track', 'Lead'); } catch (e) { /* tracking only */ }
    try { if (typeof window.gtag === 'function') window.gtag('event', 'generate_lead', { form: 'bf26_early_access_' + phase }); } catch (e) { /* tracking only */ }
  }

  function subscribe(root, listId, attributes) {
    var subscriptions = { email: { marketing: { consent: 'SUBSCRIBED' } } };
    if (attributes.phone_number) subscriptions.sms = { marketing: { consent: 'SUBSCRIBED' } };
    var profile = { email: attributes.email, subscriptions: subscriptions };
    if (attributes.phone_number) profile.phone_number = attributes.phone_number;
    var body = {
      data: {
        type: 'subscription',
        attributes: {
          custom_source: root.dataset.source || 'BF26 Early Access - Page',
          profile: { data: { type: 'profile', attributes: profile } }
        },
        relationships: { list: { data: { type: 'list', id: listId } } }
      }
    };
    return fetch('https://a.klaviyo.com/client/subscriptions?company_id=' + encodeURIComponent(root.dataset.company), {
      method: 'POST',
      headers: { 'Content-Type': 'application/vnd.api+json', revision: KLAVIYO_REVISION },
      body: JSON.stringify(body)
    }).then(function (response) {
      if (response.status !== 202 && !response.ok) throw new Error('Klaviyo ' + response.status);
      try { if (window.klaviyo && window.klaviyo.identify) window.klaviyo.identify({ email: attributes.email }); } catch (e) { /* tracking only */ }
    });
  }

  function init(root) {
    var emailForm = root.querySelector('[data-bf26-step="email"]');
    var smsForm = root.querySelector('[data-bf26-step="sms"]');
    var done = root.querySelector('[data-bf26-step="done"]');
    var word = root.querySelector('[data-bf26-word]');
    var count = root.querySelector('[data-bf26-count]');
    var state = { phase: null, step: 'email', email: '' };

    function show(el, visible) { if (el) el.hidden = !visible; }

    function renderStep() {
      var formPhase = state.phase !== 'public';
      show(emailForm, formPhase && state.step === 'email');
      show(smsForm, formPhase && state.step === 'sms');
      show(done, formPhase && state.step === 'done');
      if (done) {
        done.querySelectorAll('[data-bf26-done-for]').forEach(function (el) {
          show(el, el.getAttribute('data-bf26-done-for') === state.phase);
        });
      }
    }

    function applyPhase(phase, now) {
      var key = statementKey(root, phase, now);
      if (word) word.textContent = statementWord(root, key);
      root.querySelectorAll('[data-bf26-art]').forEach(function (el) {
        show(el, el.getAttribute('data-bf26-art') === key);
      });
      if (phase === state.phase) return;
      state.phase = phase;
      root.dataset.phase = phase;
      root.querySelectorAll('[data-bf26-group]').forEach(function (el) {
        show(el, el.getAttribute('data-bf26-group') === phase);
      });
      root.querySelectorAll('[data-bf26-cta-for]').forEach(function (el) {
        show(el, el.getAttribute('data-bf26-cta-for') === phase);
      });
      // A returning hype sign-up sees their confirmation; on early-access day they can rejoin to get the link on screen.
      if (phase === 'hype' && readJoined() && state.step === 'email') state.step = 'done';
      if (phase !== 'hype' && state.step === 'sms') state.step = 'done';
      renderStep();
    }

    function tickCountdown(now) {
      if (!count) return;
      var target = null;
      var label = '';
      var labelEl = count.querySelector('[data-bf26-count-label]');
      if (state.phase === 'hype') { target = ts(root.dataset.vipOpen); label = labelEl.dataset.labelHype; }
      if (state.phase === 'public') { target = ts(root.dataset.saleEnd); label = labelEl.dataset.labelPublic; }
      var left = target ? target - now : 0;
      if (!target || left <= 0 || (state.phase === 'hype' && state.step !== 'email')) { count.hidden = true; return; }
      var mins = Math.floor(left / 60000);
      var d = Math.floor(mins / 1440);
      var h = Math.floor((mins % 1440) / 60);
      var m = mins % 60;
      labelEl.textContent = label;
      count.querySelector('[data-u="d"]').textContent = String(d).padStart(2, '0');
      count.querySelector('[data-u="h"]').textContent = String(h).padStart(2, '0');
      count.querySelector('[data-u="m"]').textContent = String(m).padStart(2, '0');
      count.querySelector('[data-bf26-count-sr]').textContent = label + ' ' + d + ' days, ' + h + ' hours and ' + m + ' minutes';
      count.hidden = false;
    }

    function tick() {
      var now = Date.now();
      applyPhase(currentPhase(root, now), now);
      tickCountdown(now);
    }

    function setError(form, message) {
      var el = form.querySelector('[data-bf26-error]');
      var input = form.querySelector('input:not(.bf26-hp)');
      if (el) { el.textContent = message || ''; el.hidden = !message; }
      if (input) input.setAttribute('aria-invalid', message ? 'true' : 'false');
    }

    function busy(form, isBusy) {
      form.querySelectorAll('button').forEach(function (b) { b.disabled = isBusy; });
    }

    function finish() {
      state.step = 'done';
      if (state.phase === 'hype') saveJoined();
      renderStep();
      tickCountdown(Date.now());
      if (done) done.focus({ preventScroll: true });
    }

    [emailForm, smsForm].forEach(function (form) {
      if (!form) return;
      form.addEventListener('input', function () {
        var err = form.querySelector('[data-bf26-error]');
        if (err && !err.hidden) setError(form, '');
      });
    });

    if (emailForm) {
      emailForm.addEventListener('submit', function (event) {
        event.preventDefault();
        var input = emailForm.querySelector('input[type="email"]');
        var trap = emailForm.querySelector('.bf26-hp');
        var email = (input.value || '').trim();
        if (trap && trap.value) { finish(); return; }
        if (!isEmail(email)) { setError(emailForm, 'Check your email address and try again.'); input.focus(); return; }
        setError(emailForm, '');
        busy(emailForm, true);
        var listId = state.phase === 'ended' ? root.dataset.endedList : root.dataset.list;
        subscribe(root, listId, { email: email })
          .then(function () {
            state.email = email;
            trackSignup(state.phase);
            if (state.phase === 'hype' && root.dataset.sms === 'true' && smsForm) {
              saveJoined();
              state.step = 'sms';
              renderStep();
              tickCountdown(Date.now());
              var phone = smsForm.querySelector('input[type="tel"]');
              if (phone) phone.focus({ preventScroll: true });
            } else {
              finish();
            }
          })
          .catch(function () { setError(emailForm, "That didn't go through. Try again in a moment."); })
          .then(function () { busy(emailForm, false); });
      });
    }

    if (smsForm) {
      smsForm.addEventListener('submit', function (event) {
        event.preventDefault();
        var input = smsForm.querySelector('input[type="tel"]');
        var phone = normaliseMobile(input.value, root.dataset.smsCountry);
        if (!phone) { setError(smsForm, root.dataset.smsError || 'Check your mobile number and try again.'); input.focus(); return; }
        setError(smsForm, '');
        busy(smsForm, true);
        subscribe(root, root.dataset.list, { email: state.email, phone_number: phone })
          .then(finish)
          .catch(function () { setError(smsForm, "That didn't go through. Try again in a moment."); })
          .then(function () { busy(smsForm, false); });
      });
      var skip = smsForm.querySelector('[data-bf26-skip]');
      if (skip) skip.addEventListener('click', finish);
    }

    tick();
    window.setInterval(tick, 20000);
  }

  function boot() {
    document.querySelectorAll('[data-bf26]').forEach(init);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
